__turbopack_context__.v({
  "badge": "A9e6aa_badge",
  "badgeLabel": "A9e6aa_badgeLabel",
  "badgeWrap": "A9e6aa_badgeWrap",
  "badgeWrapShrink": "A9e6aa_badgeWrapShrink",
  "chevronButton": "A9e6aa_chevronButton",
  "control": "A9e6aa_control",
  "inner": "A9e6aa_inner",
  "input": "A9e6aa_input",
  "measure": "A9e6aa_measure",
});
